import {
  KeyboardAvoidingView,
  Platform,
  ScrollView,
  StyleSheet,
} from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { SelectedSetsData } from '@/components/SetsSelectedData';
import { useSentenceSetContext } from '@/contexts/SentenceSetContext/useSentencesetContext';
import { StackScreenProps } from '@react-navigation/stack';
import { TherapistStackParamList } from '@/navigations/TherapistStack';
import { Filter } from './Filter';
import { Header } from './Header';

const innerStyles = StyleSheet.create({
  container: { flex: 1 },
  scrollStyle: { flex: 1, gap: 20, margin: 28 },
});

type SetsSelectedWrapperProps = {
  props: StackScreenProps<TherapistStackParamList, 'SentenceSet'>;
};

export function SetsSelectedWrapper({ props }: SetsSelectedWrapperProps) {
  const {
    data,
    selectedData,
    changeSelectedData,
    patientId,
    page,
    changePage,
    limitModal,
    changeLimitModal,
    setId,
    editData,
    dataKeyName,
    apiKeyName,
    dynamicName,
    scrollViewRef,
    template,
  } = useSentenceSetContext();

  const propz = {
    data,
    selectedData,
    changeSelectedData,
    patientId,
    page,
    changePage,
    limitModal,
    changeLimitModal,
    setId,
    editData,
    dataKeyName,
    apiKeyName,
    dynamicName,
    template,
  };

  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === 'ios' ? 'padding' : undefined}
      style={{ flex: 1 }}
      keyboardVerticalOffset={Platform.OS === 'ios' ? 80 : 0}
    >
      <SafeAreaView style={innerStyles.container}>
        <Header props={props} />
        <ScrollView ref={scrollViewRef} style={innerStyles.scrollStyle}>
          <Filter />
          <SelectedSetsData {...propz} />
        </ScrollView>
      </SafeAreaView>
    </KeyboardAvoidingView>
  );
}
